/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfAllergy } from '../../models/data-page-of-allergy';

export interface AllergyList$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
  pageNumber?: number;
  sortbydirection?: string | null;
  searchText?: string | null;
}

export function allergyList(http: HttpClient, rootUrl: string, params?: AllergyList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfAllergy>> {
  const rb = new RequestBuilder(rootUrl, allergyList.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('sortbydirection', params.sortbydirection, {});
    rb.query('searchText', params.searchText, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfAllergy>;
    })
  );
}

allergyList.PATH = '/allergy/list';
